import { Component, Injector, Optional, Input } from '@angular/core';

import { ArtikelLeverancierService } from 'src/app/core/service/artikel-leverancier.service';
import { ArtikelLeverancier } from 'src/app/core/dto/artikel-leverancier';
import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Artikel } from 'src/app/core/dto/artikel';

@Component({
    selector: 'c-i-j-borculo-artikel-leverancier-collection',
    templateUrl: './artikel-leverancier-collection.component.html'/*,
    styleUrls: ['./artikel-leverancier-collection.component.css'] */
})
export class ArtikelLeverancierCollectionComponent extends PagedCollectionComponent<ArtikelLeverancier> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<ArtikelLeverancier>([
		{ colDef: 'leverancierID', prop: x => x.leverancierID.naam1, searchable: SearchableType.String },
		{ colDef: 'artikelCodeLeverancier', prop: x => x.artikelCodeLeverancier, searchable: SearchableType.String },
		{ colDef: 'prijs', prop: x => x.prijs, searchable: SearchableType.Number },
		{ colDef: 'datum', prop: x => x.datum, searchable: SearchableType.Date }		
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: ArtikelLeverancierService, @Optional() protected filter: Filter<ArtikelLeverancier>, injector: Injector) {
        super('/artikelLeverancier/artikelLeverancier', injector, ArtikelLeverancier);

		this.initInput('artikelID', this.filterBuilder.equal(x => x.artikelID.id));

		this.filter.onGetChipLabel(x => x.leverancierID.naam1, () => 'Leverancier');
		this.filter.onGetChipLabel(x => x.artikelCodeLeverancier, () => 'ArtikelCode');
		this.filter.onGetChipLabel(x => x.prijs, () => 'Prijs');
		this.filter.onGetChipLabel(x => x.datum, () => 'Datum');
		
    }

	displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are already filtered on
		if(colDef.colDef == 'artikelID' && this.artikelID != null) { return false; }

		return super.displayColumn(colDef, ix);
	}

	@Input() set artikelID(val: Artikel) { this.handleInput('artikelID', val.id); }
}